<template>
  <v-dialog
    v-model="show"
    max-width="450"
    persistent
  >
    <v-card>
      <v-card-title class="title grey lighten-4">
        Transferir processos
      </v-card-title>

      <v-card-text class="px-3 pb-0">
        Todos os processos deste usuário serão tramitados para o usuário selecionado abaixo.

        <v-autocomplete
          label="Usuário"
          v-model="selectedEmployee"
          :items="activeEmployees"
          :loading="isLoading"
          :search-input.sync="search"
          item-text="name"
          no-data-text="Nenhum resultado encontrado"
          return-object
          class="mt-2"
        />
      </v-card-text>

      <v-card-actions class="px-3 pb-3">
        <v-btn
          flat
          @click="close"
          :disabled="loadingTransfer"
        >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="docgo white--text"
          @click="transferProcesses"
          :loading="loadingTransfer"
          :disabled="isEmpty(selectedEmployee)"
        >
          Transferir processos
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import EmployeeService from '@/services/system/EmployeeService';
  import foldersService from '@/services/FoldersService';
  import { isEmpty } from 'lodash';

  export default {
    name: 'folder-transfer-dialog',
    props: ['employee'],
    data() {
      return {
        show: false,
        activeEmployees: [],
        selectedEmployee: null,
        search: '',
        isLoading: false,
        loadingTransfer: false,
        interval: null,
        isEmpty,
      };
    },
    methods: {
      open() {
        this.show = true;
      },
      close() {
        this.show = false;
      },
      getActiveEmployees() {
        EmployeeService.all({
          limit: 5,
          page: 1,
          q: this.search,
          status: 'active',
        })
          .then(({data}) => {
            this.activeEmployees = data.employees;
          })
          .catch(({response}) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              timeout: 6000,
              color: 'error',
              message: response.data,
              messageIcon: 'mdi-check',
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
      transferProcesses() {
        this.loadingTransfer = true;
        foldersService
          .transferProcesses({
            activeId: this.selectedEmployee.id,
            inactiveId: this.employee.id,
          })
          .then(({ data }) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'success',
              message: data.message,
              timeout: 6000,
            });
            this.close();
          })
          .catch(({ response }) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'error',
              message: response.data.error,
              timeout: 6000,
              messageIcon: 'mdi-alert-outline',
            });
          })
          .finally(() => {
            this.loadingTransfer = false;
          });
      },
    },
    watch: {
      search(val) {
        if(!val) {
          this.selectedEmployee = null;
          return;
        }

        clearInterval(this.interval)
        this.interval = setTimeout(() => {
          this.isLoading = true;
          this.getActiveEmployees();
        }, 500);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/folder/entity/FolderTransferDialog.vue